import { useMemo } from 'react'
import useSWR from 'swr'
import { uniqBy } from 'lodash-es'
import { fetchViewConfig } from '@vt/apis/lib-ex/v2/views'
import { fetchTbOperationAuthorityConfig } from '@vt/apis/lib-ex/v2/authority'
import { parseView } from '@vt/apis/lib-ex/utils/transformers'

const inlineactionTypes = [
  'detailConfig',
  'logConfig',
  'editorConfig',
  'recoveryConfig',
  'deleteConfig',
  'downloadConfig',
]
// 用于合并 viewConfig , 有几个应用场景
// 1. 回收站叠加 filters(transformer已处理)
// 2. 叠加权限(正在进行)
// 3. 叠加默认的 viewConfig(接口已处理)
const mergeAuthorityViewConfig = (
  viewConfig,
  authorityConfig,
  userInfoInApp
) => {
  const finalViewConfig = { ...viewConfig }
  const { operatorConfig, recycle: recycleOperatorConfig } =
    finalViewConfig.operatorConfig || finalViewConfig
  // 回收站
  // const {r}
  const finalOperatorConfig = {
    ...operatorConfig,
    elements: (operatorConfig && operatorConfig.elements) || [],
  }
  if (!authorityConfig || authorityConfig.length === 0) {
    return viewConfig
  }

  const arr = []
  authorityConfig.forEach((config = {}) => {
    const { operable = {}, range, superRole } = config.authority || {}
    // 取出权限下可操作的类型
    const { actionTypes = [] } = operable
    // 目前只判断 custom、self
    // custom 自定义，即直接走视图配置不作处理
    if (range === 'custom') {
      return
    }

    actionTypes.forEach((action) => {
      const viewActionInfo = finalViewConfig[action] || {}
      let currentRange = range
      if (userInfoInApp && superRole && superRole.length) {
        const obj = superRole.find((v) => v.roleSlug === userInfoInApp.roleSlug)
        if (obj) {
          currentRange = obj.range
        }
      }
      let allowType = 'all'
      if (currentRange === 'self') {
        // 自己创建的才有权限
        allowType = 'createBySelf'
      } else if (currentRange === 'selfBindArea') {
        allowType = 'selfBindArea'
      }

      finalViewConfig[action] = {
        ...viewActionInfo,
        allow: true,
        allowType, // 自己创建的
      }
      if (inlineactionTypes.includes(action)) {
        arr.push(action)
        finalOperatorConfig.elements.push({
          type: 'linkButton',
          actionType: action,
        })
      }
    })
  })
  const finalElements = finalOperatorConfig.elements
  return {
    ...finalViewConfig,
    operatorConfig: {
      recycle: recycleOperatorConfig,
      operatorConfig: {
        ...finalOperatorConfig,
        elements: uniqBy(finalElements, 'actionType'),
      },
    },
  }
}

// 获取视图设置( 临时加个tbSlug供获取操作权限用，之后要去掉，因为获取权限之后要通过tbId)
export const useViewConfigSWR = (
  appId,
  tbId,
  vid,
  opts,
  tbSlug,
  userInfoInApp
) => {
  const { data, mutate, error } = useSWR(
    ['fetch-view-info', appId, tbId, vid, opts.includeDefs],
    {
      fetcher: () => {
        return Promise.all([
          fetchViewConfig({
            appId,
            tbId,
            vid,
            includeDefs: opts.includeDefs,
          }),
          fetchTbOperationAuthorityConfig(appId, tbId, tbSlug),
        ]).then((result) => {
          return { viewConfig: result[0], authorityConfig: result[1] }
        })
      },
    }
  )

  const memodViewConfig = useMemo(() => {
    if (data) {
      const { viewConfig, authorityConfig } = data
      return mergeAuthorityViewConfig(
        viewConfig && parseView(viewConfig),
        authorityConfig,
        userInfoInApp
      )
    }
    return null
  }, [data])

  return {
    viewConfig: memodViewConfig,
    mutateViewConfig: mutate,
    isViewConfigLoading: !error && !data && vid,
    fetchViewDataError: error,
  }
}
